import React, { useEffect, useState } from 'react';
import Swal from 'sweetalert2';
import AdminNavBar from './AdminNavBar';

const pastelColors = [
  '#ccb4d6', '#f8e1f4', '#b4e7f8', '#f8e7b4', '#e1f8d6', '#f8b4c4'
];

const AdminPhotoSessions = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(20);
  const [total, setTotal] = useState(0);
  const [searching, setSearching] = useState(false);

  const fetchData = async (params = {}) => {
    setLoading(true);
    try {
      const url = new URL('https://api.laviopaperie.com/api/photo-sessions');
      url.searchParams.set('page', params.page || page);
      url.searchParams.set('limit', params.limit || limit);
      if (params.startDate || startDate) url.searchParams.set('start', params.startDate || startDate);
      if (params.endDate || endDate) url.searchParams.set('end', params.endDate || endDate);
      const res = await fetch(url.toString());
      const json = await res.json();
      if (json.success) {
        setData(json.data);
        setTotal(json.total);
        setPage(json.page);
        setLimit(json.limit);
      } else {
        Swal.fire({ icon: 'error', title: 'Gagal load data', text: json.message, confirmButtonColor: pastelColors[0] });
      }
    } catch {
      Swal.fire({ icon: 'error', title: 'Server error', confirmButtonColor: pastelColors[0] });
    }
    setLoading(false);
  };

  useEffect(() => { fetchData({ page: 1 }); }, []);

  const handleSearch = (e) => {
    e.preventDefault();
    setPage(1);
    setSearching(true);
    fetchData({ page: 1, startDate, endDate });
    setTimeout(() => setSearching(false), 800);
  };

  const totalPages = Math.ceil(total / limit);

  // Helper: cek expired
  const isExpired = (createdAt) => {
    if (!createdAt) return false;
    const created = new Date(createdAt);
    const now = new Date();
    const diff = (now - created) / (1000 * 60 * 60 * 24); // hari
    return diff >= 3;
  };

  return (
    <div style={{
      minHeight: '100vh',
      width: '100vw',
      background: `linear-gradient(120deg, ${pastelColors.join(', ')})`,
      backgroundSize: '300% 300%',
      animation: 'pastelBg 18s ease-in-out infinite',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'flex-start',
      padding: '40px 0',
    }}>
      <AdminNavBar active="/admin/photo-sessions" />
      <h2 style={{ fontFamily: 'Quicksand, sans-serif', color: '#7c5fa6', fontWeight: 700, fontSize: 32, marginBottom: 24 }}>Admin Photo Sessions</h2>
      <form onSubmit={handleSearch} style={{ display: 'flex', gap: 12, marginBottom: 32, alignItems: 'center', flexWrap: 'wrap' }}>
        <label style={{ fontWeight: 600 }}>Start Date</label>
        <input type="date" value={startDate} onChange={e => setStartDate(e.target.value)} style={{ padding: '8px', borderRadius: 8, border: '1px solid #ccb4d6' }} />
        <label style={{ fontWeight: 600 }}>End Date</label>
        <input type="date" value={endDate} onChange={e => setEndDate(e.target.value)} style={{ padding: '8px', borderRadius: 8, border: '1px solid #ccb4d6' }} />
        <button type="submit" disabled={searching} style={{ padding: '10px 24px', borderRadius: 999, border: 'none', background: searching ? pastelColors[1] : 'linear-gradient(90deg, #a28ad6 0%, #f8e1f4 100%)', color: '#fff', fontSize: 18, fontWeight: 700, letterSpacing: 2, boxShadow: '0 4px 16px 0 rgba(204,180,214,0.18)', cursor: searching ? 'not-allowed' : 'pointer', transition: 'all 0.2s' }}>Search</button>
      </form>
      <div style={{ width: '95vw', maxWidth: 900, background: 'rgba(255,255,255,0.92)', borderRadius: 16, boxShadow: '0 4px 24px 0 rgba(204,180,214,0.12)', padding: 24 }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontFamily: 'Quicksand, sans-serif', fontSize: 16 }}>
          <thead>
            <tr style={{ background: '#f8e1f4' }}>
              <th style={{ padding: 10, borderRadius: 8 }}>Session ID</th>
              <th style={{ padding: 10, borderRadius: 8 }}>Email</th>
              <th style={{ padding: 10, borderRadius: 8 }}>Created At</th>
              <th style={{ padding: 10, borderRadius: 8 }}>Action</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={4} style={{ textAlign: 'center', padding: 24 }}>Loading...</td></tr>
            ) : data.length === 0 ? (
              <tr><td colSpan={4} style={{ textAlign: 'center', padding: 24 }}>Tidak ada data</td></tr>
            ) : data.map(row => {
              const expired = isExpired(row.created_at);
              return (
                <tr key={row.id} style={{ background: row.email ? '#e1f8d6' : '#fff' }}>
                  <td style={{ padding: 10, textAlign: 'center', fontWeight: 700, letterSpacing: 2 }}>{row.indukname}</td>
                  <td style={{ padding: 10, textAlign: 'center', color: row.email ? '#4caf50' : '#a28ad6', fontWeight: 700 }}>{row.email || '-'}</td>
                  <td style={{ padding: 10, textAlign: 'center' }}>{row.created_at ? new Date(row.created_at).toLocaleString() : '-'}</td>
                  <td style={{ padding: 10, textAlign: 'center' }}>
                    {!expired ? (
                      <a href={`/final-output/${row.indukname}`}
                        style={{
                          display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                          padding: '10px', borderRadius: 999,
                          background: 'linear-gradient(90deg, #b4e7f8 0%, #ccb4d6 100%)',
                          color: '#7c5fa6', fontSize: 22, textDecoration: 'none',
                          boxShadow: '0 2px 8px #ccb4d633', border: 'none',
                          cursor: 'pointer', transition: 'all 0.18s cubic-bezier(.4,2,.6,1)',
                        }}
                        onMouseOver={e => {
                          e.currentTarget.style.transform = 'scale(1.13)';
                          e.currentTarget.style.background = 'linear-gradient(90deg, #f8e1f4 0%, #b4e7f8 100%)';
                          e.currentTarget.style.boxShadow = '0 4px 18px #ccb4d699';
                        }}
                        onMouseOut={e => {
                          e.currentTarget.style.transform = 'scale(1)';
                          e.currentTarget.style.background = 'linear-gradient(90deg, #b4e7f8 0%, #ccb4d6 100%)';
                          e.currentTarget.style.boxShadow = '0 2px 8px #ccb4d633';
                        }}
                        title="Final Output"
                      >
                        <span role="img" aria-label="output">🖼️</span>
                      </a>
                    ) : (
                      <span style={{ color: '#ff6b81', fontWeight: 700 }}>Media Expired</span>
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        {/* Pagination */}
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 12, marginTop: 24 }}>
          <button disabled={page <= 1} onClick={() => { setPage(page - 1); fetchData({ page: page - 1 }); }} style={{ padding: '8px 18px', borderRadius: 999, border: 'none', background: page <= 1 ? '#eee' : pastelColors[0], color: '#7c5fa6', fontWeight: 700, cursor: page <= 1 ? 'not-allowed' : 'pointer' }}>Prev</button>
          <span style={{ fontWeight: 700, color: '#7c5fa6' }}>Page {page} of {totalPages}</span>
          <button disabled={page >= totalPages} onClick={() => { setPage(page + 1); fetchData({ page: page + 1 }); }} style={{ padding: '8px 18px', borderRadius: 999, border: 'none', background: page >= totalPages ? '#eee' : pastelColors[0], color: '#7c5fa6', fontWeight: 700, cursor: page >= totalPages ? 'not-allowed' : 'pointer' }}>Next</button>
        </div>
      </div>
    </div>
  );
};

export default AdminPhotoSessions;
